import classNames from "classnames/bind";
import Carousel from "common/blocks/Carousel";
import ResponseVehicleAdCard from "common/blocks/VehicleAdCard/ResponseVehicleAdCard";
import useMediaQuery from "hooks/useMediaQuery/useMediaQuery";
import { ResolvedVehicleCardSettings } from "resolvers/data/vehicleCardSettingsResolver";
import { ResolvedVehicleDisplaySettings } from "resolvers/pages/pdpPageResolver";
import { ResponseVehicle } from "services/motorpoint/shortlist";

import styles from "./CarouselView.module.scss";

const cx = classNames.bind(styles);

interface CarouselViewProps {
    title: string;
    vehicles: ResponseVehicle[];
    shortlistedStocks: number[];
    onClick: (vehicle: ResponseVehicle, index: number) => void;
    vehicleCardSettings: ResolvedVehicleCardSettings;
    vehicleDisplaySettings: ResolvedVehicleDisplaySettings;
}

const CarouselView = ({
    title,
    shortlistedStocks,
    vehicles,
    onClick,
    vehicleCardSettings,
    vehicleDisplaySettings,
}: CarouselViewProps) => {
    const { isMobile, isTablet, isTabletLarge, isPortrait } = useMediaQuery();

    const slidesOffsetBefore = isMobile ? 12 : isTablet ? 42 : isTabletLarge && isPortrait ? 22 : 0;
    const slidesOffsetAfter = isMobile ? 12 : isTablet ? 42 : isTabletLarge && isPortrait ? 22 : 0;
    const spaceBetween = isMobile ? 10 : 20;

    return (
        <div className={cx("row", "wrapper")}>
            <div className={cx("recomendedVehicles")}>
                <Carousel
                    id="RecommendedVehiclesCarousel"
                    title={title}
                    className={cx("carousel")}
                    navigationClassName={cx("carouselNavigation", {
                        disabled:
                            (isMobile && vehicles?.length === 1) ||
                            (isTablet && vehicles && vehicles?.length <= 2),
                    })}
                    slidesOffsetBefore={slidesOffsetBefore}
                    slidesOffsetAfter={slidesOffsetAfter}
                    spaceBetween={spaceBetween}
                >
                    {vehicles?.map((vehicle, index) => (
                        <ResponseVehicleAdCard
                            className={cx("vehicleAdCard")}
                            key={vehicle?.StockBookNumber}
                            {...vehicle}
                            isSaved={(shortlistedStocks ?? []).includes(vehicle?.StockBookNumber)}
                            isRecentlyViewed={true}
                            onClick={() => onClick(vehicle, index)}
                            vehicleCardSettings={vehicleCardSettings}
                            vehicleDisplaySettings={vehicleDisplaySettings}
                        />
                    ))}
                </Carousel>
            </div>
        </div>
    );
};

export default CarouselView;
